var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEatingHabits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFC05D;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97,53.1h-2.1c-0.7,0-1.2,0.5-1.2,1.2v28.6c0,1.2-1,2.2-2.2,2.2h-0.4c-1.2,0-2.2-1-2.2-2.2V54.3 c0-0.7-0.5-1.2-1.2-1.2h-2.9c-0.7,0-1.2,0.5-1.2,1.2v28.6c0,1.2-1,2.2-2.2,2.2H81c-1.2,0-2.2-1-2.2-2.2V54.3c0-0.7-0.5-1.2-1.2-1.2 h-2.1c-0.7,0-1.2,0.5-1.2,1.2v35.5c0,4.8,3.5,8.7,8,9.5v56.9c0,1.9,1.6,3.5,3.5,3.5h0.9c1.9,0,3.5-1.6,3.5-3.5V99.3 c4.5-0.8,8-4.7,8-9.5V54.3C98.2,53.6,97.6,53.1,97,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.2,54c-0.7-0.7-1.7-1.2-2.8-1.2c-0.9,0-1.8,0.3-2.4,0.8c-0.5,0.4-0.9,0.9-1.2,1.6l0,0 c-0.1,0.2-0.1,0.3-0.2,0.5l0,0L112,90.4c-1,2.9-0.6,6,1.1,8.5l10.4,16.3v40.1c0,2.2,1.8,3.9,3.9,3.9c2.2,0,3.9-1.8,3.9-3.9V56.8 C131.3,55.7,130.9,54.7,130.2,54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEatingHabits);
export default __webpack_public_path__ + "static/media/Eating_Habits.d3e8525917ae1ba879ebd9d07ebb802d.svg";
export { ForwardRef as ReactComponent };